import { FC } from 'react';
import { Popover } from 'antd';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import MobileModal from '~src/shared/mobileModal/MobileModal';
import { SvgIconName } from '~src/shared/SvgIcon';

import * as SC from './popoverInfo.sc';

interface Props {
  isAnonymous?: boolean;
  isSelfAssessment?: boolean;
  t?: i18next.TFunction;
  selection?: string | null;
}

const PopoverInfo: FC<Props> = ({ isAnonymous, selection = null, isSelfAssessment }) => {
  const { t } = useTranslation();
  const selectionString = selection ? `.${selection}` : null;
  let isAnonString = isAnonymous ? '.isanonymous' : '.notanonymous';
  let isAnonIcon = isAnonymous ? 'iconAnonymous' : ('iconEye' as SvgIconName);
  if (isSelfAssessment) {
    isAnonString = '.self_assessment';
    isAnonIcon = 'iconEye' as SvgIconName;
  }
  const anonTxtKey = `x.questionstream.navbar${selection ? selectionString : isAnonString}`;
  const anonTxtHoverKey = `${anonTxtKey}.hover.text`;
  const isAnon = !!(isAnonymous && !isSelfAssessment);
  return (
    <>
      <MobileModal
        trigger={
          <SC.IsAnonymous>
            <SC.AnonText
              data-translation={anonTxtKey}
              $anon={!!(isAnonymous && !isSelfAssessment)}
              $selection={selection || null}
            >
              {t(anonTxtKey)}
            </SC.AnonText>
            {!selection && <SC.AnonContainer $anon={isAnon} name={isAnonIcon} />}
          </SC.IsAnonymous>
        }
        content={<SC.AnonInfoText data-translation={anonTxtHoverKey}>{t(anonTxtHoverKey)}</SC.AnonInfoText>}
        header={<SC.AnonContainer $anon={isAnon} name={isAnonIcon} />}
      />
      <SC.WebModalContainer>
        <Popover
          trigger="hover"
          content={
            <div style={{ maxWidth: 250 }}>
              {!selection && <SC.AnonContainer $anon={isAnon} name={isAnonIcon} />}
              <div data-translation={anonTxtHoverKey}>{t(anonTxtHoverKey)}</div>
            </div>
          }
        >
          <SC.IsAnonymous>
            <SC.AnonText data-translation={anonTxtKey} $anon={isAnon} $selection={selection || null}>
              {t(anonTxtKey)}
            </SC.AnonText>
            {!selection && <SC.AnonContainer $anon={isAnon} name={isAnonIcon} />}
          </SC.IsAnonymous>
        </Popover>
      </SC.WebModalContainer>
    </>
  );
};

export default PopoverInfo;
